import React from 'react';
import Experience from 'app/common/react/components/experiences/Experience/Experience';
import PropTypes from 'prop-types';
import WebPushManager from 'app/common/lib/WebPushManager';
import { Touchable } from 'gestalt';

// 500439 is for firefox push. This is temperory and for experiment use only. This experience should be merge in
// PCONST.thrift.Experience.WEB_DIRECT_SYSTEM_DESKTOP_PUSH when we ship firefox push.
const EXPERIENCE_IDS = [
  PCONST.thrift.Experience.WEB_DIRECT_SYSTEM_DESKTOP_PUSH,
  PCONST.thrift.Experience.WEB_POST_NUX_DESKTOP_PUSH,
  PCONST.thrift.Experience.WEB_POST_NUX_DESKTOP_PUSH_FIREFOX,
];

const ExperienceSystemPush = ({ placementId }) => (
  <Experience placementId={placementId} experienceIds={EXPERIENCE_IDS}>
    {({ experience_id, complete, dismiss, display_data }) => {
      WebPushManager.instance().subscribe(complete, dismiss);
      return (
        <Touchable onTouch={dismiss} fullWidth={false}>
          <div className="experienceSystemPushOverlay" />;
        </Touchable>
      );
    }}
  </Experience>
);

ExperienceSystemPush.propTypes = {
  placementId: PropTypes.number.isRequired,
};

export default ExperienceSystemPush;
